export default {
  '请求': {
    '加载中': 'Laden...',
    '请求失败': 'Verzoek mislukt',
    '登录已过期': 'Sessie verlopen',
    '网络连接失败': 'Netwerkverbinding mislukt',
    '请重新登录': 'Log opnieuw in',
    '没有权限访问': 'Toegang geweigerd',
    '请求的资源不存在': 'Bron niet gevonden',
    '服务器错误': 'Serverfout',
    '网络错误': 'Netwerkfout',
    '刷新成功': 'Vernieuwd',
    '获取中': 'Laden......',
    '账号下线': 'Account offline',
    '功能已禁用': 'Functie uitgeschakeld',
  },
  '导航': {
    '首页': 'Home',
    '选妃': 'Kiezen',
    '认证': 'Verifiëren',
    '影院': 'Video',
    '个人': 'Mijn',
  },
  '首页': {
    '注册': 'Registreren',
    '影片': 'Video',
    '女团': 'Girls',
    '热门城市': 'Populaire steden:',
    '经理预订': 'Managerboeking',
    '看更多': 'Meer',
    '身份验证': 'Geverifieerd',
    '身高': 'Lengte',
    '胸围': 'Borstomvang',
    '服务城市': 'Stad:',
  },
  '女团': {
    '女团': 'Girls',
    '选妃': 'Kiezen',
    '身份验证': 'Geverifieerd',
    '身高': 'Lengte',
    '胸围': 'Borstomvang',
    '服务城市': 'Stad:',
    '注册': 'Registreren',
    '请联系顾问或接待员': 'Neem contact op met een adviseur',
  },
  '登录': {
    '登录会员视窗': 'Ledenlogin',
    '请输入用户名': 'Gebruikersnaam',
    '请输入密码': 'Wachtwoord',
    '登录': 'Inloggen',
    '没有账号马上注册': 'Geen account? Registreren',
    '登录成功': 'Succesvol ingelogd',
    '登录注册': 'Inloggen / Registreren',
    '登录可享受更多服务': 'Log in voor meer diensten!',
  },
  '注册': {
    '注册': 'Registreren',
    '登录': 'Inloggen',
    '请输入用户名': 'Gebruikersnaam',
    '用户名规则': '6-20 letters/cijfers',
    '请输入密码': 'Wachtwoord',
    '密码规则': '6-16 letters en cijfers',
    '请输入验证码': 'Captcha',
    '验证码规则': 'Voer 4-cijferige captcha in',
    '请输入邀请码': 'Uitnodigingscode',
    '邀请码规则': 'Voer agent-uitnodigingscode in',
    '同意协议': 'Ik ben 18+ en ga akkoord met de Voorwaarden',
    '立即注册': 'Nu registreren',
    '注册中': 'Registreren...',
    '已有账号马上登录': 'Al een account? Inloggen',
    '注册成功': 'Geregistreerd!',
    '注册失败': 'Registratie mislukt: ',
    '验证码错误': 'Ongeldige captcha',
    '请同意注册条款': 'Ga akkoord met de voorwaarden',
    '用户名已存在': 'Gebruikersnaam bestaat al',
    '邀请码无效': 'Ongeldige uitnodigingscode',
  },
  '抢单': {
    '今日收益': 'Inkomen vandaag',
    '余额': 'Saldo',
    '订单': 'Orders',
    '开始抢单': 'Order pakken',
    '当前等级': 'Niveau:',
    '提现': 'Opnemen',
    '在线客服': 'Support',
    '充值': 'Opwaarderen',
    '幸运任务': 'Gelukstaak',
    '幸运订单': 'Geluksorder',
    '幸运订单提示': 'Gefeliciteerd! Order met hoge commissie',
    '恭喜获得幸运订单': 'Geluksorder ontvangen!',
    '提交订单': 'Order indienen',
    '未完成订单提示': 'U heeft een onbetaalde order. Betaal eerst.',
    '正在获取订单': 'Order laden...',
    '抢单时间': 'Paktijd:',
    '订单号': 'Ordernr.',
    '订单总额': 'Totaal',
    '佣金': 'Commissie',
    '商品单价': 'Prijs',
    '预计收入': 'Geschatte verdiensten',
    '确认支付': 'Nu betalen',
    '确认付款': 'Betaling bevestigen',
    '支付处理中': 'Verwerken...',
    '取消': 'Annuleren',
    '去查看': 'Bekijken',
    '暂无可用订单': 'Geen beschikbare orders',
    '正在加载用户信息': 'Gebruikersinfo laden...',
    '今日抢单已达上限': 'Daglimiet bereikt',
    '余额不足无法获取订单': 'Onvoldoende saldo',
    '获取订单失败': 'Order ophalen mislukt',
    '支付成功': 'Betaling geslaagd',
    '支付失败': 'Betaling mislukt',
    '支付失败请重试': 'Betaling mislukt, probeer opnieuw',
    '请完成任务单后进入': 'Voltooi eerst de taken',
    '请设置收款卡': 'Koppel een uitbetalingsadres',,
    '当前余额': 'Huidig saldo',
    '还需缴纳': 'Nog te betalen',
  },
  '我的': {
    '我的页面': 'Mijn pagina',
    '钻石': 'Diamant',
    '信誉分': 'Krediet',
    '开通专属会员': 'VIP openen',
    '开启一次日期不限': 'Eenmalige ontgrendeling, geen datalimiet',
    '提现': 'Opnemen',
    '历史订单': 'Ordergeschiedenis',
    '充值记录': 'Opwaardeergeschiedenis',
    '提现记录': 'Opnamegeschiedenis',
    '添加钱包地址': 'Walletadres toevoegen',
    '邀请码': 'Uitnodigingscode:',
    '余额': 'Saldo',
    '退出登陆': 'Uitloggen',
  },
  '会员': {
    '会员等级': 'Lidmaatschap:',
    '普通等级': 'Normaal',
    '当前等级': 'Huidig',
    '立即开通': 'Activeren',
    '免费说明': '(Gratis video\'s) (Gratis matching)',
    '所需投资': 'Vereiste investering',
    '佣金': 'Commissie',
    '订单': 'Orders',
    '加入': 'Deelnemen >>',
  },
  '充值': {
    '充值': 'Opwaarderen',
    '当前余额': 'Saldo',
    '余额': 'Saldo: ',
    '个': '',
    '充值金额': 'Bedrag',
    '请输入充值金额': 'Voer bedrag in',
    '快速选择金额': 'Snel bedrag',
    '确认': 'Bevestigen',
    '提示': 'Tip',
    '金额错误': 'Ongeldig bedrag',
    '立即充值': 'Nu opwaarderen',
    '提交成功': 'Ingediend, in afwachting van controle',
  },
  '提现': {
    '提现': 'Opnemen',
    '兑换积分': 'Punten opnemen',
    '最大提款金额': 'Max. bedrag',
    '资金密码': 'Fondswachtwoord',
    '余额': 'Saldo: ',
    '个': '',
    '钱包地址': 'Walletadres: ',
    '请选择提款地址': 'Selecteer opnameadres',
    '暂无绑定地址': 'Nog geen adres gekoppeld',
    '提交': 'Indienen',
    '通知': 'Melding:',
    '单笔最大提现': '1. Max. per opname: ',
    '单笔最低提现': '2. Min. per opname: ',
    '检查姓名账号': '3. Controleer naam en rekening',
    '注意提款费用': '4. Let op opnamekosten',
    '请填写正确的金额': 'Voer een geldig bedrag in',
    '当前余额': 'Saldo',
    '提现金额': 'Bedrag',
    '请输入提现数量': 'Voer bedrag in',
    '立即提现': 'Nu opnemen',
    '交易密码': 'Betaalwachtwoord',
    '请输入交易密码': 'Voer betaalwachtwoord in',
    '请先设置提现密码': 'Stel eerst een opnamewachtwoord in',
  },
  '绑卡': {
    '添加钱包地址': 'Walletadres toevoegen',
    '钱包地址信息': 'Walletgegevens',
    '请输入支付卡信息': 'Voer uw walletadres in',
    '加密货币类型': 'Cryptotype',
    '请选择加密货币类型': 'Selecteer cryptotype',
    '钱包地址': 'Walletadres',
    '请输入钱包地址': 'Voer walletadres in',
    '绑卡说明': 'Beste gebruiker, koppel voor de veiligheid van uw fondsen uw echte naam en stel een opnamewachtwoord in. De naam moet overeenkomen met het account.',
    '确定绑卡': 'Koppeling bevestigen',
    '绑卡提示': 'Tip: koppel een grote bank. Neem contact op met support om te wijzigen.',
    '请先设置姓名': 'Stel eerst uw naam in!',
    '已绑定不可修改': 'Adres al gekoppeld. Neem contact op met support om te wijzigen.',
  },
  '订单历史': {
    '订单历史': 'Ordergeschiedenis',
    '数据为空': 'Geen gegevens',
    '订单号': 'Ordernr.: ',
    '已完成': 'Voltooid',
    '处理中': 'In behandeling',
    '完成订单': 'Order voltooien',
    '订单金额': 'Bedrag: ',
    '佣金': 'Commissie: ',
    '创建时间': 'Aangemaakt: ',
    '上一页': 'Vorige',
    '下一页': 'Volgende',
    '获取失败': 'Geschiedenis laden mislukt',
    '获取失败重试': 'Laden mislukt, probeer opnieuw',
    '未知': 'Onbekend',
    '完成成功': 'Order voltooid!',
    '完成失败': 'Voltooien mislukt: ',
    '完成失败重试': 'Voltooien mislukt, probeer opnieuw',
    '请输入支付密码': 'Voer betaalwachtwoord in',
    '请先设置支付密码': 'Stel eerst een betaalwachtwoord in',
  },
  '入金记录': {
    '标题': 'Opwaardeergeschiedenis',
    '数据为空': 'Geen gegevens',
    '认证结果': 'Resultaat',
    '下单积分': 'Punten: ',
    '下单时间': 'Besteld: ',
    '结算时间': 'Verrekend: ',
    '待审核': 'In afwachting',
    '已通过': 'Goedgekeurd',
    '已拒绝': 'Afgewezen',
    '暂无数据': 'Geen gegevens',
  },
  '提现记录': {
    '标题': 'Opnamegeschiedenis',
    '数据为空': 'Geen gegevens',
    '待审核': 'In afwachting',
    '审核成功': 'Goedgekeurd',
    '审核退回': 'Afgewezen',
    '未知状态': 'Onbekend',
    '金额': 'Bedrag: ',
    '说明': 'Opmerking: ',
    '提交时间': 'Ingediend: ',
    '审核时间': 'Beoordeeld: ',
    '已通过': 'Goedgekeurd',
    '已拒绝': 'Afgewezen',
    '暂无数据': 'Geen gegevens',
  },
  '资料': {
    '基本信息': 'Profiel',
    '头像': 'Avatar',
    '姓名': 'Naam',
    '未设置': 'Niet ingesteld',
    '性别': 'Geslacht',
    '男': 'Man',
    '女': 'Vrouw',
    '未知': 'Onbekend',
    '设定': 'Instellingen',
    '账号信息': 'Account',
    '更改登录密码': 'Inlogwachtwoord wijzigen',
    '设定支付密码': 'Betaalwachtwoord instellen',
    '退出登录': 'Uitloggen',
    '设置': 'Instellingen',
    '登录密码': 'Inlogwachtwoord',
    '资金密码': 'Fondswachtwoord',
    '提现密码已设置': 'Opnamewachtwoord ingesteld. Neem contact op met support om te wijzigen.',
    '已设置': 'Ingesteld',
    '修改真实姓名': 'Echte naam bewerken',
    '请输入真实姓名': 'Voer echte naam in',
    '真实姓名说明': 'Echte naam moet overeenkomen met de walletgegevens',
    '提交': 'Indienen',
    '请勿重复设置': 'Al ingesteld!',
    '修改登录密码': 'Inlogwachtwoord wijzigen',
    '设置资金密码': 'Fondswachtwoord instellen',
    '保存': 'Opslaan',
    '旧密码': 'Oud wachtwoord',
    '请输入旧密码': 'Voer oud wachtwoord in',
    '新密码': 'Nieuw wachtwoord',
    '请输入新密码': 'Voer nieuw wachtwoord in',
    '确认密码': 'Bevestig wachtwoord',
    '请再次输入新密码': 'Voer nieuw wachtwoord opnieuw in',
    '请填写完整': 'Vul alle velden in!',
    '两次密码不一致': 'Wachtwoorden komen niet overeen',
    '性别修改': 'Geslacht bewerken',
    '个人报表': 'Persoonlijk rapport',
    '任务金额积分': 'Taakbedrag (punten)',
    '盈利公式': 'Winst = Winstbedrag − Taakbedrag',
    '任务金额': 'Taakbedrag',
    '充值金额': 'Opwaardering',
    '金额': 'Bedrag',
    '中奖金额': 'Winstbedrag',
    '个人情报': 'Profiel',
    '身高': 'Lengte:',
    '胸围': 'Borstomvang:',
    '收费区间': 'Prijsbereik:',
    '系统公告': 'Aankondigingen',
  },
  '客服': {
    '联系客服': 'Contact opnemen met support',
    '在线客服': 'Online support',
    '暂无客服': 'Geen support beschikbaar',
    '联系': 'Contact',
    '服务时间': '24/7 tot uw dienst',
  },
  '影院': {
    '影院': 'Bioscoop',
    '全部': 'Alles',
    '最高分': 'Best beoordeeld',
    '播放': 'Weergaven: ',
    '次播放': ' weergaven',
    '热门推荐': 'Populair',
    '播放次数': 'Weergaven:',
    '请充值后观看': 'Waardeer op om te kijken',
  },
  '语言切换器': {
    '切换语言': 'Taal',
    '语言': 'Taal',
  },
}
